export default "<siu-button-list\r\ncolor=\"primary\"\r\n[itemsList]=\"ListaBotnesItems\"\r\n(on-click)=\"accionClickList($event)\"\r\n></siu-button-list>"